import Vue from "vue";
// import md5 from "js-md5";
import config from "@/config";
import errorTags from "@/errorTags";

const cart = {
  merchant_id: "",
  store_id: "",
  merchant_name: "",
  store_name: "",
  order_list: []
};

const merchantConstraints = {
  id: 0,
  dinein_minimum: "",
  dinein_extra: "",
  reserve_minimum: "",
  reserve_extra: "",
  pickup_minimum: "",
  pickup_extra: "",
  delivery_minimum: "",
  delivery_extra: ""
};

export default {
  namespaced: true,
  state: {
    _loading: {
      login: false,
      logout: false
    },
    sessionToken: "",
    customerId: "",
    customerName: "",
    customerEmail: "",
    customerPhone: "",
    customerAddress: "",
    cart: cart,
    dinein: cart,
    lasturl: null,
    latitude: null,
    longitude: null,
    checkout: null,
    merchantConstraints: merchantConstraints,
    displayType: 0
  },
  mutations: {
    updateUrl(state, payload) {
      state.lasturl = payload;
    },
    updateCheckout(state, payload) {
      state.checkout = payload;
    },
    updateAddress(state, payload) {
      state.customerAddress = payload;
    },
    updateLocation(state, payload) {
      state.latitude = payload.latitude;
      state.longitude = payload.longitude;
    },
    customerLogin(state, payload) {
      state.sessionToken = payload.customer_sessiontoken;
      state.customerId = payload.customer_id;
      state.customerName = payload.customer_name;
      state.customerEmail = payload.customer_email;
      state.customerPhone = payload.customer_phoneno;
    },
    delete(state) {
      state.sessionToken = "";
      state.customerId = "";
      state.customerName = "";
      state.customerEmail = "";
      state.customerPhone = "";
    },
    //normal anybook cart functions
    addToCart(state, payload) {
      if (state.cart.merchant_id !== payload.merchant_id) {
        state.cart.order_list = new Array();
        state.cart.merchant_id = payload.merchant_id;
        state.cart.store_id = payload.store_id;
        state.cart.merchant_name = payload.merchant_name;
        state.cart.store_name = payload.store_name;
      }
      state.cart.order_list.push(payload.order_item);
    },
    removeFromCart(state, payload) {
      state.cart.order_list.splice(payload, 1);
      if (state.cart.order_list.length === 0)
        state.cart = Object.assign(new Object(), cart);
    },
    clearCart(state) {
      state.cart = Object.assign(new Object(), cart);
    },
    //cart functions only for IN STORE DINE IN OR TAKE AWAY
    addToDineIn(state, payload) {
      if (state.dinein.merchant_id !== payload.merchant_id) {
        state.dinein.order_list = new Array();
        state.dinein.merchant_id = payload.merchant_id;
        state.dinein.store_id = payload.store_id;
        state.dinein.merchant_name = payload.merchant_name;
        state.dinein.store_name = payload.store_name;
      }
      state.dinein.order_list.push(payload.order_item);
    },
    removeFromDineIn(state, payload) {
      state.dinein.order_list.splice(payload, 1);
      if (state.dinein.order_list.length === 0)
        state.dinein = Object.assign(new Object(), cart);
    },
    clearDineIn(state) {
      state.dinein = Object.assign(new Object(), cart);
    },
    storeConstraint(state, payload) {
      state.merchantConstraints.id = payload.constraintId;
      state.merchantConstraints.dinein_minimum = payload.dineInMinimum;
      state.merchantConstraints.dinein_extra = payload.dineInExtra;
      state.merchantConstraints.reserve_minimum = payload.reserveMinimum;
      state.merchantConstraints.reserve_extra = payload.reserveExtra;
      state.merchantConstraints.pickup_minimum = payload.pickupMinimum;
      state.merchantConstraints.pickup_extra = payload.pickupExtra;
      state.merchantConstraints.delivery_minimum = payload.deliveryMinimum;
      state.merchantConstraints.delivery_extra = payload.deliveryExtra;
    },
    updateDisplayType(state, payload) {
      state.displayType = payload;
    }
  }
};
